import { useState } from 'react';
import { ToastContainer } from 'react-toastify';

import { FindPassword, SignIn, SignUp } from '../index';
import { AuthorizationModal, ModalBody } from './Authorization.styled';
import { IAuthorizationProps } from './Authorization.types';
import { AUTHORIZATION_STEP } from '../../Constants';

export const MODAL_BACKDROP = {
	STATIC: 'STATIC',
	DYNAMIC: true,
};

const AuthorizationComponent = (props: IAuthorizationProps) => {
	const {
		isOpenAuthorization,
		setIsOpenAuthorization,
		authorizationStep,
		setAuthorizationStep,
		setDiscoverTutorialModal,
		setIsAdmin,
		setIsLoggedIn,
	} = props;

	const [modalBackdrop, setModalBackdrop] = useState<string | boolean>(
		MODAL_BACKDROP.DYNAMIC
	);

	const changeStep = (step: string) => {
		setAuthorizationStep(step);
	};

	const changeBackdropBehaviour = (backdrop: string | boolean) => {
		setModalBackdrop(backdrop);
	};

	const showDiscoverTutorialModal = () => {
		setDiscoverTutorialModal(true);
	};

	const onHide = () => setIsOpenAuthorization(false);

	const stepProps = () => ({
		changeStep,
		changeBackdropBehaviour,
		showDiscoverTutorialModal,
		onHide,
		setIsAdmin,
		setIsLoggedIn,
	});

	const authorizationModalProps = () => ({
		backdrop: modalBackdrop,
		show: isOpenAuthorization,
		onHide,
		centered: true,
	});

	return (
		<AuthorizationModal {...authorizationModalProps()}>
			<ToastContainer />
			<ModalBody>
				{authorizationStep === AUTHORIZATION_STEP.LOGIN && (
					<SignIn {...stepProps()} />
				)}
				{authorizationStep === AUTHORIZATION_STEP.REGISTER && (
					<SignUp {...stepProps()} />
				)}
				{authorizationStep === AUTHORIZATION_STEP.FIND_PASSWORD && (
					<FindPassword changeStep={changeStep} />
				)}
			</ModalBody>
		</AuthorizationModal>
	);
};

export default AuthorizationComponent;
